import { MapPin, Star, ArrowLeft, Briefcase, MessageSquare } from "lucide-react";
import { Link, useNavigate, useParams } from "react-router-dom";
import MOCK_WORKERS from "../utils/mockWorkers";

const WorkerProfile = () => {
  const { id } = useParams();
  const navigate = useNavigate();

  /* 🔥 FIXED MATCH (STRING vs NUMBER) */
  const workerA = MOCK_WORKERS.find((w) => String(w.id) === id);

  if (!workerA) {
    return (
      <div className="min-h-screen flex items-center justify-center text-xl">
        Worker not found
      </div>
    );
  }

  /* 🔥 DYNAMIC DATA (NO HARDCODE) */
  const worker = {
    name: workerA.name,
    verified: true,
    role: workerA.trade,
    experience: `${workerA.exp || workerA.experienceYears} years`,
    wage: `₹${workerA.rate || workerA.baseAsk}/day`,
    location: "Delhi, India",
    distance: "2.5 km away",
    rating: workerA.rating || 4.7,
    completedJobs: 120,
    match: "95% Match",
    avatar: "/images/worker_large.jpg",
    skills: workerA.skills || ["Wiring", "Repair", "Installation"],
    bio: `Experienced ${workerA.trade} with strong expertise in field work, safety, and reliability.`,
    portfolio: [
      "/images/worker6.webp",
      "/images/worker7.jpg",
      "/images/worker8.webp",
    ],
    reviews: [
      {
        name: "Amit Singh",
        rating: 5,
        comment: "Great work, very professional!",
      },
      {
        name: "Sunita",
        rating: 4.5,
        comment: "Quick and reliable.",
      },
    ],
  };

  return (
    <div className="min-h-screen bg-gradient-to-br from-blue-50 via-white to-emerald-50 pt-28 pb-20 px-6">

      {/* BACK */}
      <div className="max-w-5xl mx-auto mb-6">
        <Link
          to="/postjob"
          className="flex items-center gap-2 text-slate-600 hover:text-slate-900"
        >
          <ArrowLeft size={20} /> Back
        </Link>
      </div>

      {/* CARD */}
      <div className="max-w-5xl mx-auto bg-white/80 backdrop-blur-xl rounded-3xl shadow-xl border p-8">

        {/* HEADER */}
        <div className="flex flex-col md:flex-row items-center gap-10">

          {/* AVATAR */}
          <div className="w-40 h-40 rounded-3xl overflow-hidden shadow-lg">
            <img src={worker.avatar} className="w-full h-full object-cover" />
          </div>

          {/* INFO */}
          <div className="flex-grow">
            <h1 className="text-3xl font-extrabold flex items-center gap-2">
              {worker.name}
              {worker.verified && (
                <span className="px-3 py-1 text-xs rounded-full bg-green-100 text-green-700">
                  ✔ Verified
                </span>
              )}
            </h1>

            <p className="text-lg text-slate-600 mt-1">
              {worker.role} • {worker.experience}
            </p>

            <div className="flex items-center gap-5 mt-3">
              <div className="flex items-center gap-1 text-orange-500 font-semibold">
                <Star size={18} /> {worker.rating}
              </div>
              <div className="text-slate-600">
                {worker.completedJobs} jobs completed
              </div>
              <span className="px-3 py-1 text-xs bg-purple-100 text-purple-700 rounded-full">
                {worker.match}
              </span>
            </div>

            <div className="flex items-center gap-2 text-slate-600 mt-3">
              <MapPin size={18} /> {worker.location}
              <span className="text-xs text-slate-500">
                ({worker.distance})
              </span>
            </div>

            <p className="mt-3 font-semibold text-emerald-600 text-lg">
              {worker.wage}
            </p>

            {/* 🔥 BUTTONS (UNCHANGED FUNCTIONALITY) */}
            <div className="mt-6 flex gap-4">

              <button
                onClick={() => navigate(`/hire/${workerA.id}`)}
                className="px-6 py-3 rounded-xl bg-gradient-to-r from-blue-600 to-emerald-500 text-white font-semibold shadow-md flex items-center gap-2"
              >
                <Briefcase size={18} /> Hire
              </button>

              <button
                onClick={() => navigate(`/chat/${workerA.id}`)}
                className="px-6 py-3 rounded-xl border border-slate-300 text-slate-700 font-semibold flex items-center gap-2"
              >
                <MessageSquare size={18} /> Chat
              </button>

            </div>
          </div>
        </div>

        {/* ABOUT */}
        <div className="mt-12">
          <h2 className="text-xl font-bold">About</h2>
          <p className="text-slate-700 mt-2">{worker.bio}</p>
        </div>

        {/* SKILLS */}
        <div className="mt-10">
          <h2 className="text-xl font-bold">Skills</h2>
          <div className="flex flex-wrap gap-2 mt-3">
            {worker.skills.map((skill, i) => (
              <span key={i} className="px-3 py-1 rounded-full bg-slate-200 text-sm">
                {skill}
              </span>
            ))}
          </div>
        </div>

        {/* PORTFOLIO */}
        <div className="mt-10">
          <h2 className="text-xl font-bold">Portfolio</h2>
          <div className="grid grid-cols-3 gap-4 mt-4">
            {worker.portfolio.map((img, i) => (
              <img key={i} src={img} className="rounded-xl h-32 w-full object-cover" />
            ))}
          </div>
        </div>

        {/* REVIEWS */}
        <div className="mt-12">
          <h2 className="text-xl font-bold">Reviews</h2>
          <div className="space-y-4 mt-4">
            {worker.reviews.map((r, i) => (
              <div key={i} className="p-4 bg-slate-50 rounded-xl border">
                <p className="font-semibold flex items-center gap-2">
                  {r.name}
                  <span className="text-orange-500 flex items-center gap-1">
                    <Star size={16} /> {r.rating}
                  </span>
                </p>
                <p className="text-sm mt-1">{r.comment}</p>
              </div>
            ))}
          </div>
        </div>

      </div>
    </div>
  );
};

export default WorkerProfile;